module.exports = function() {
  return new Worker(__webpack_public_path__ + "0dad65a38c1b75a7ae07.worker.js");
};